import {
	IHealthProblemCoSoItemRequest,
	IHealthProblemHocSinhItemRequest,
} from '../../models/request/y-te/yTeRequests';
import { healthproblem } from '../../models/response/y-te/healthproblem';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_HEALTH_PROBLEM_PATH = 'health-problem';

class HealthProblemApi extends BaseCRUDApi<healthproblem> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	/** Danh mục bệnh + cờ `da_dang_ky` của cơ sở → trang cấu hình */
	SelectAllCheckDangKy(dm_coso_id: number) {
		return apiClient.get(`${API_HEALTH_PROBLEM_PATH}/check_dang_ky/${dm_coso_id}`);
	}
	/** Chỉ bệnh đã đăng ký ở cơ sở */
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`${API_HEALTH_PROBLEM_PATH}/select_by_coso/${dm_coso_id}`);
	}
	SelectByHocSinh(ts_hocsinh_id: number, nam_hoc: string) {
		return apiClient.get(`${API_HEALTH_PROBLEM_PATH}/hoc-sinh/${ts_hocsinh_id}/nam-hoc/${nam_hoc}`);
	}
	InsertMultiple(request: IHealthProblemCoSoItemRequest) {
		return apiClient.post(`${API_HEALTH_PROBLEM_PATH}/insert-multiple`, request);
	}
	InsertStudentMedicalHistory(request: IHealthProblemHocSinhItemRequest) {
		return apiClient.post(`${API_HEALTH_PROBLEM_PATH}/student-medical-history`, request);
	}
	DeleteByHocSinh(ts_hocsinh_id: number, nam_hoc: string) {
		return apiClient.delete(
			`${API_HEALTH_PROBLEM_PATH}/student-medical-history/hoc-sinh/${ts_hocsinh_id}/nam-hoc/${nam_hoc}`
		);
	}
	SelectStudentMedicalHistory(dm_coso_id: number, nam_hoc: string) {
		return apiClient.get(
			`${API_HEALTH_PROBLEM_PATH}/student-medical-history/co-so/${dm_coso_id}/nam-hoc/${nam_hoc}`
		);
	}
	/** `language` phải là giá trị backend/SP hiểu: 'vn' | 'en' (xem helper `toApiLanguage`) */
	SelectStudentMedicalHistoryDetail(dm_coso_id: number, nam_hoc: string, language: string) {
		return apiClient.get(
			`${API_HEALTH_PROBLEM_PATH}/student-medical-history-detail/co-so/${dm_coso_id}/nam-hoc/${nam_hoc}/language/${language}`
		);
	}
}
export const healthProblemApi = new HealthProblemApi(API_HEALTH_PROBLEM_PATH);
